import { useEffect, useState } from "react";
import Formulario from 'components/Formulario/Formulario';
import { StyledForm } from 'components/Formulario/styles';
import { InputTableModalPerfisDeAcesso } from "constants/constantesInputsFormulario";

function GerenciadorDePerfis({
  direitos,
  perfisAcesso,
  perfisAcessoAoDireitoAdicionados,
  setPerfisAcessoAoDireitoAdicionados
}) {
  const [form] = StyledForm.useForm();
  const [inputsFormulario, setInputsFormulario] = useState([]);

  useEffect(() => {
    gerarInputsFormulario();
  }, []);

  useEffect(() => {
    gerarInputsFormulario();
  }, [direitos, perfisAcesso, perfisAcessoAoDireitoAdicionados]);

  const gerarInputsFormulario = () => {
    const inputs = 
    [
      InputTableModalPerfisDeAcesso(perfisAcessoAoDireitoAdicionados, direitos, perfisAcesso)
    ]
    setInputsFormulario(inputs);
  }

  const onValuesChange = (changedValues, allValues) => {
    setPerfisAcessoAoDireitoAdicionados(changedValues.perfisAcesso);
  };

  return (
    <Formulario
        inputsData={inputsFormulario}
        formReference={form}
        onValuesChange={onValuesChange}
        hideSubmitButton={true}
    />
  );
};

export default GerenciadorDePerfis;